// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"296":"final","443":"about"}[chunkId] || chunkId) + "." + {"188":"2b0a7cf0","296":"900ae2a2","443":"fed7237a","601":"f3308716"}[chunkId] + ".css";
};